import axios from 'axios';
import lstModules from 'common/json/lstModules.json';

const tokenid = localStorage.getItem("tokenid");
const httpURL = lstModules['performance'].url + ":" + lstModules['performance'].port + "/sms/syllabus";

export const saveSyllabusSubjectListSvc = (syllabusId, lstSubject, cbSaveSyllabusSubject) => {
    const obj = { status: "", message: "" };

    var formData = new FormData()
    formData.append('syllabusId', syllabusId)
    formData.append('lstSubject', JSON.stringify(lstSubject))
    axios({
        url: httpURL + '/save_dtls',
        method: 'POST',
        data: formData,
        headers: { tokenid: tokenid },
        withCredentials: true
    })
        .then(Response => {
            var data = Response.data
            obj.status = data.SvcStatus;
            obj.message = data.SvcMsg;
            cbSaveSyllabusSubject(obj)
        })
        .catch(error => {
            obj.status = 'Exception';
            obj.message = error.message;
            cbSaveSyllabusSubject(obj)

            // console.log('error')
        })
}

export const getSyllabusSubjectListSvc = (syllabusId, cbSubjectList) => {
    // console.log("getSubjectListSvc called, syllabusId", syllabusId);
    const formData = new FormData();
    formData.append("syllabusId", syllabusId);
    const obj = { status: "", message: "" };
    axios({
        url: httpURL + '/subject_list_dtls',
        method: "POST",
        headers: { 'tokenid': tokenid },
        // params:{"syllabusId":syllabusId},
        data: formData,
        withCredentials: true,
    }).then((response) => {
        // console.log("response in getSubjectListSvc", response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.lstSubject = response.data.lstSubject;
        }
        cbSubjectList(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        cbSubjectList(obj);
    })
}
